export enum SavingState {
    Initial = 'INITIAL',
    Saving = 'SAVING',
    Failure = 'FAILURE',
    Success = 'SUCCESS',
    UgyldigVedlegg = 'VEDLEGG_UGYLDIG',
    UnauthorizedUser = 'UNAUTHORIZED_USER',
    BadRequestFailure = 'BAD_REQUEST_FAILURE',
}
